<div class="header_second">
    <div class="Dashboard_head">Stall Users

        <button mat-icon-button class="back-btn" (click)="goBack()">

            <mat-icon>arrow_back</mat-icon>

        </button>
    </div>

</div>

<div class="page-content">

    <!-- Add User Section -->
    <mat-card class="section-card">
        <div class="section-header">
            <mat-icon class="section-icon add-icon">person_add</mat-icon>
            <span class="section-title">Add New User</span>
        </div>

        <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="user-form">

            <div class="form-row">

                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Full Name</mat-label>
                    <mat-icon matPrefix>person</mat-icon>
                    <input matInput formControlName="name" placeholder="Enter full name">

                    <mat-error *ngIf="userForm.get('name')?.hasError('required')">
                        Name is required
                    </mat-error>

                    <mat-error *ngIf="userForm.get('name')?.hasError('pattern')">
                        Name cannot be blank
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Mobile Number</mat-label>
                    <mat-icon matPrefix>phone</mat-icon>

                    <input matInput type="tel" maxlength="10" formControlName="mobile"
                        placeholder="10-digit mobile number">

                    <mat-error *ngIf="userForm.get('mobile')?.hasError('required')">
                        Mobile number is required
                    </mat-error>

                    <mat-error *ngIf="userForm.get('mobile')?.hasError('pattern')">
                        Enter a valid 10-digit mobile number
                    </mat-error>
                </mat-form-field>

                <!-- </div>

                <div class="form-row"> -->

                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Role</mat-label>
                    <mat-icon matPrefix>badge</mat-icon>

                    <mat-select formControlName="role">
                        <mat-option *ngFor="let role of roleOptions" [value]="role">
                            {{ role }}
                        </mat-option>
                    </mat-select>

                    <mat-error *ngIf="userForm.get('role')?.hasError('required')">
                        Role is required
                    </mat-error>
                </mat-form-field>

                <div class="submit-wrapper">

                    <button mat-flat-button color="primary" type="submit" class="add-user-btn"
                        [disabled]="isSubmitting">

                        <mat-icon>
                            {{ isSubmitting ? 'hourglass_empty' : 'add_circle' }}
                        </mat-icon>

                        {{ isSubmitting ? 'Adding...' : 'Add User' }}

                    </button>

                </div>

            </div>

        </form>

    </mat-card>

    <!-- User List Section -->
    <mat-card class="section-card users-list-section">

        <div class="section-header">
            <mat-icon class="section-icon list-icon">people</mat-icon>

            <span class="section-title">
                User List
            </span>

            <span class="user-count-badge" *ngIf="!isLoading">
                {{ usersList.length }}
            </span>
        </div>

        <!-- Loading -->
        <div *ngIf="isLoading" class="loading-state">

            <mat-progress-spinner diameter="40" mode="indeterminate">
            </mat-progress-spinner>

            <span>Loading users...</span>

        </div>

        <!-- Empty State -->
        <div *ngIf="!isLoading && usersList.length === 0" class="empty-state">

            <mat-icon class="empty-icon">
                group_off
            </mat-icon>

            <h3>No Users Found</h3>

            <p>
                No users have been added to this stall yet.
            </p>

        </div>

        <!-- Users Table -->
        <div *ngIf="!isLoading && usersList.length > 0" class="users-table-wrapper">

            <table class="users-table">

                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Mobile</th>
                        <th>Role</th>
                    </tr>
                </thead>

                <tbody>

                    <tr *ngFor="let user of usersList; let i = index" class="user-row">

                        <td class="row-num">
                            {{ i + 1 }}
                        </td>

                        <td>

                            <div class="user-name-cell">

                                <div class="user-avatar">
                                    {{ user.name?.charAt(0)?.toUpperCase() }}
                                </div>

                                <span>
                                    {{ user.name }}
                                </span>

                            </div>

                        </td>

                        <td>
                            {{ user.mobile }}
                        </td>

                        <td>

                            <span class="role-badge">
                                {{ user.role }}
                            </span>

                        </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </mat-card>

</div>